import React, { useEffect, useState } from 'react';

import { CustomLoadingProgress } from '../../shared/components/CustomLoadingProgress';

import ScriptService from '../services/ScriptService';
import usePaymentSettings from '../../shared/hooks/usePaymentSettings';
import ErrorPanel from './ErrorPanel';

declare var paypal: any;

export type PaymentUIResult = 'cancel' | 'error' | 'success' | 'fail';

interface PaymentButtonProps {
  id: string;
  item: string;
  price: number;
  currency: string;
  onClick: () => void;
  onComplete: (result: PaymentUIResult, details: any) => void;
}

function PaymentButton(props: PaymentButtonProps) {
  const [payPalButtonLoaded, setPayPalButtonLoaded] = useState(false);
  const { loading, error, paymentSettings } = usePaymentSettings();

  useEffect(() => {
    if (!!paymentSettings) {
      const paypalUrl = `https://www.paypal.com/sdk/js?client-id=${paymentSettings.clientId}&currency=${props.currency}`;
      ScriptService.load(paypalUrl, () => init());
    }
  }, [paymentSettings]);

  const containerID = `paypal-button-container-${props.id}`;

  function init() {
    setPayPalButtonLoaded(true);
  }

  useEffect(() => {
    if (!payPalButtonLoaded || error) {
      return;
    }
    paypal
      ?.Buttons({
        style: {
          layout: 'horizontal',
          shape: 'pill'
        },
        createOrder: function (data: any, actions: any) {
          props.onClick();
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: props.price,
                  currency: props.currency
                },
                payment_descriptor: `Bracken - Course ${props.item}`,
                item_list: {
                  items: [
                    {
                      name: props.item,
                      quantity: 1,
                      price: props.price,
                      currency: props.currency
                    }
                  ]
                }
              }
            ]
          });
        },
        onApprove: function (data: any, actions: any) {
          return actions.order.capture().then(function (details: any) {
            if (details.error === 'INSTRUMENT_DECLINED') {
              console.log('Transaction declined:' + JSON.stringify(details));
              props.onComplete('fail', details);
              return actions.restart();
            }
            console.log('Transaction complted:' + JSON.stringify(details));
            props.onComplete('success', details);
          });
        },
        onCancel: function (data: any) {
          console.log(`Transaction cancelled: ${JSON.stringify(data)}`);
          props.onComplete('cancel', null);
        },
        onError: function (error: any) {
          console.log(`Transaction error: ${JSON.stringify(error)}`);
          props.onComplete('error', null);
        }
      })
      .render(`#${containerID}`);
  }, [payPalButtonLoaded]);

  if (!payPalButtonLoaded) {
    return <CustomLoadingProgress />;
  }

  if (error) {
    return <ErrorPanel title="Loading PayPal button has failed." />;
  }

  return <div id={containerID}></div>;
}

export default PaymentButton;
